module.exports = __webpack_public_path__ + "img/green_127.f0893dc2.png";